// extracted by mini-css-extract-plugin
export default {"contents":"HE-z","sectionHeading":"IE-z"};